<template>
  <div class="dropdown">
    <button class="btn btn-link text-decoration-none" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <span class="fa-stack mr-1">
        <i class="fa fa-fw fa-stack-1x fa-volume-up"></i>
        <i
          v-if="muted === true"
          class="fa fa-fw fa-ban fa-stack-2x"
          style="opacity:0.75"
        ></i>
      </span>
      <i
        v-if="playing === true"
        class="fa fa-fw fa-play"
      ></i>
      <i
        v-if="playing === false"
        class="fa fa-fw fa-pause"
      ></i>
      <span class="ml-1 d-none d-md-inline-block">
        Inspiration
      </span>
    </button>
    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu2">
      <a
        v-if="canManage"
        href="/admin/resources/videos"
        class="dropdown-item"
        target="_blank"
      >
        Manage Videos
      </a>
      <a
        v-if="canStream && !isLive"
        href="#"
        class="dropdown-item"
        @click.prevent="startCreatingStream()"
      >
        Go Live
      </a>
      <a
        v-if="canStream && isLive"
        href="#"
        class="dropdown-item"
        @click.prevent="startEndingStream()"
      >
        End Stream
      </a>
      <div
        v-if="canStream"
        class="dropdown-divider"
      ></div>
      <a
        v-if="muted === false"
        href="#"
        class="dropdown-item"
        @click.prevent="playerObj.mute()"
      >
        Mute
      </a>
      <a
        v-if="muted === true"
        href="#"
        class="dropdown-item"
        @click.prevent="playerObj.unmute()"
      >
        Unmute
      </a>
      <a
        v-if="playing === true"
        href="#"
        class="dropdown-item"
        @click.prevent="playerObj.pause()"
      >
        Pause
      </a>
      <a
        v-if="playing === false"
        href="#"
        class="dropdown-item"
        @click.prevent="playerObj.play()"
      >
        Play
      </a>
      <div v-if="playerObj && playerObj.tracks.length">
        <div class="dropdown-divider"></div>
        <a
          v-for="(track, i) in playerObj.tracks"
          v-bind:key="track.id"
          href="#"
          class="dropdown-item media align-items-center"
          @click.prevent="playerObj.play(i)"
        >
          <span class="media-left mr-3">
            <span
              class="thumb"
              :style="track.thumbnail ? `background-image:url(${track.thumbnail});` : ''"
            >
              <i
                v-if="currentTrack === i"
                class="fa fa-play"
              ></i>
            </span>
          </span>
          <span class="media-body">
            <span class="d-block text-truncate video-title">
              {{ track.title || 'Untitled' }}
            </span>
            <!--
            <span class="text-muted small d-block">
              7 minutes
            </span>
            -->
          </span>
        </a>
      </div>
    </div>
    <b-modal
      id="create-stream"
      title="Start a Live Stream"
      :hide-footer="true"
    >
      <p>
        Enter the live streaming URL below. This video
        will be placed into the Business Planning Video queue
        and will start immediately.
      </p>
      <b-input
        v-model="videoUrl"
        size="lg"
        placeholder="https://www.youtube.com/watch?v=..."
      ></b-input>
      <b-checkbox
        v-model="embed"
      >
        This is an <code>&lt;iframe&gt;</code> (embed)
      </b-checkbox>
      <hr>
      <b-button
        variant="flat-peter-river"
        :disabled="!videoUrl"
        @click.prevent="createStream()"
      >
        Go Live
      </b-button>
      <b-button variant="link" @click.prevent="$bvModal.hide('create-stream')">
        Cancel
      </b-button>
    </b-modal>
  </div>
</template>

<style scoped>
.video-title {
  max-width: 230px;
}

.thumb {
  background-size: cover;
  background-position: center center;
  background-color: #999;
  background-repeat: no-repeat;
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
</style>

<script>
import { get } from 'lodash'
import { createLiveStream, createLiveEmbed, endLiveStream } from '@/api'
import urls from '@/api/urls'
import alertify from 'alertify.js'

export default {
  props: {
    player: {
      type: String,
      required: true
    },
    canStream: {
      type: Boolean,
      default: false
    },
    canManage: {
      type: Boolean,
      default: false
    },
    isLive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      playerObj: null,
      playing: null,
      muted: null,
      currentTrack: null,
      embed: false,
      videoUrl: '',
      creatingStream: false
    }
  },
  mounted () {
    this.playerObj = get(this.$parent.$refs, this.player)

    this.playerObj.$on('player.play', () => {;
      this.playing = true
    })

    this.playerObj.$on('player.pause', () => {
      this.playing = false
    })

    this.playerObj.$on('player.muted', () => {
      this.muted = true
    })

    this.playerObj.$on('player.unmuted', () => {
      this.muted = false
    })

    this.playerObj.$on('player.playlistitem', () => {
      this.currentTrack = this.playerObj.player.playlist.currentItem()
    })
  },
  methods: {
    startCreatingStream () {
      this.$bvModal.show('create-stream')
    },
    async createStream() {
      if (this.videoUrl) {
        this.creatingStream = true
        try {
          await this.embed ?
            createLiveEmbed(this.videoUrl, [], 'business-pan') :
            createLiveStream(this.videoUrl, 'business-plan')
          document.location.reload()
        } catch (e) {
          //
        } finally {
          this.creatingStream = false
        }
      }
    },
    startEndingStream () {
      alertify.confirm('Are you sure you want to end the live stream?', () => {
        this.endStream()
      })
    },
    async endStream () {
      await endLiveStream('business-plan')
      document.location.replace(urls.businessPlan.showTracker('prospect'))
    }
  }
}
</script>
